import { investigationTypes, placeholders, territorialEntity } from './case-data';
import { searchQuery } from './../../actions/global-actions';
import Swal from 'sweetalert2';
import { provinces } from './../../actions/global-actions-data';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../styles/cases.css';
import { createCase } from './../../actions/case-actions';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from 'react-date-picker';

function CreateCase(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);

    const [dropdown, setDropdown] = useState({
        show: false,
        value: '',
        data: []
    })

    const [form, setForm] = useState({
        date: new Date(),
        client: {
            clientId: ''
        },
        clientText: '',
        attorneyInCharge: {
            userId: ''
        },
        attorneyText: '',
        representative: '',
        caseType: '',
        case: {
            position: '',
            statePosition: '',
            territorialEntity: '',
            executionProvince: '',
            executionCity: '',
        },
        researchOrgan: {
            organId: ''
        },
        researchOrganText: '',
        filingNumber: '',
        city: '',
        province: '',
        summary: '',
        observation: '',
        events: '',
        instance: '',
        autoOpening: '',
        autoOpeningDate: '',
        notificationDate: '',
    })

    const [citiesData, setCitiesData] = useState({
        caseCities: [],
        clientCities: []
    });

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleDateChange = ( name, date ) => {
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleCaseInputChange = (event) => {
        setForm({
            ...form,
            case: {
                ...form.case,
                [event.target.name] :  event.target.value
            }
        })
    }

    const handleSearchChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
        if (event.target.value.length > 2) {
            dispatch( searchQuery( event.target.id, event.target.value, searchFunction, user.token ) );
        } else {
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const searchFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setDropdown({ show: true, value: link, data: data.data });
        }
    }

    const setOrganData = ( data ) => {
        setForm({
            ...form,
            researchOrgan: {
                organId: data._id
            },
            researchOrganText: data.description
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const setClientData = ( data ) => {
        setForm({
            ...form,
            client: {
                clientId: data._id
            },
            clientText: data.firstName + ' ' + data.lastName + ' ' + data.documentType + ': ' + data.document,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const setAttorneyData = ( data ) => {
        setForm({
            ...form,
            attorneyInCharge: {
                userId: data._id
            },
            attorneyText: data.firstName + ' ' + data.lastName + ' ' + data.documentType + ': ' + data.document + ' TP:' + data.professionalCard,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const handleOnChange = (event, position) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;
            if (position === 'case') {
                setCitiesData({
                    ...citiesData,
                    caseCities: cities
                })
                setForm({
                    ...form,
                    [event.target.name]: event.target.value
                })
            } else {
                setCitiesData({
                    ...citiesData,
                    clientCities: cities
                })
                setForm({
                    ...form,
                    case: {
                        ...form.case,
                        [event.target.name]: event.target.value
                    }
                })
            }      
        } else {
            if (position === 'case') {
                setCitiesData({
                    ...citiesData,
                    caseCities: []
                })
                setForm({
                    ...form,
                    city :  '',
                    province: ''
                })
            } else {
                setCitiesData({
                    ...citiesData,
                    clientCities: []
                })
                setForm({
                    ...form,
                    case: {
                        ...form.case,
                        executionCity :  '',
                        executionProvince: ''
                    }
                })
            }
        }
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:`Debe llenar todos los campos, excepto "Personero delegado / Funcionario sustenciador" para continuar`,
            });
        } else {
            dispatch( createCase( form, createFunction, user.token) );
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( field !== 'representative' && (form[field] === '' || form[field] === null)) {
                    return true
                }
            }
        }
        return false
    }

    const createFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            if (user.userType === 'Administrador') {
                navigate(currentLink + '/editar/' + data.data._id)
            } else {
                navigate(currentLink)
            }
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Caso creado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Nuevo caso</h1>
                <form className="d-flex w-100 flex-wrap" onSubmit={handleOnSubmit}>
                    <h4 className="w-100 my-2">Datos Generales</h4>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field">Fecha del documento</label>
                        <DatePicker
                            value={ form.date }
                            dayAriaLabel={"Día"}
                            dayPlaceholder={"dd"}
                            monthAriaLabel={"Mes"}
                            monthPlaceholder={"mm"}
                            yearAriaLabel={"Año"}
                            yearPlaceholder={"yyyy"}
                            name={"date"}
                            onChange={ (date)=>handleDateChange( 'date', date ) }
                            dateFormat="MM/dd/yyyy"
                        />
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="caseType">Tipo de investigación</label>
                        <select className="input-field" id="caseType" name="caseType" onChange={handleInputChange}>
                            <option></option>
                            {investigationTypes.map((documentType, index) => (
                                <option key={index} value={documentType.value}>{documentType.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="filingNumber">Radicado de la investigación</label>
                        <input type="text" className="input-field" id="filingNumber" autoComplete="off" placeholder="Número de radicado de investigación" onChange={handleInputChange} name="filingNumber"></input>
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="province">Departamento</label>
                        <select className="input-field" id="province" name="province" onChange={(e) =>handleOnChange(e, 'case')}>
                            <option></option>
                            {provinces.map((province) => (
                                <option key={province.name} value={province.name}>{province.name}</option>
                            ))}
                        </select>
                    </div>
                    {form.province !== '' && citiesData.caseCities && citiesData.caseCities !== [] ? 
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="city">Ciudad del caso</label>
                            <select className="input-field" id="city" name="city" onChange={handleInputChange}>
                                <option></option>
                                {citiesData.caseCities.map((city) => (
                                    <option key={city.name} value={city.name}>{city.name}</option>
                                ))}
                            </select>
                        </div>
                        :''}
                    <div className="d-flex flex-column w-3 field position-relative">
                        <label className="label-field" htmlFor="research-organ-or-control">Órgano de investigación</label>
                        <input type="text" autoComplete='off' className="input-field" id="research-organ-or-control" placeholder="Buscar órgano de investigación por su nombre" onChange={handleSearchChange} name="researchOrganText" value={form.researchOrganText}></input>
                        <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'research-organ-or-control') ? "active" : ""}`}>
                            { dropdown.data.length > 0 ? 
                                dropdown.data.map((option, index) => (
                                    <div key={index} className="dropdown-item-container" onClick={() => setOrganData(option)}>{option.description}</div>
                                ))
                            :
                                <span className="dropdown-message-item">Sin resultados, <a target="_blank" rel="noreferrer" href={"/organos-investigacion/nuevo"}>¿crear?</a></span>
                            }
                        </div>
                    </div>
                    <div className="d-flex flex-column w-3 field position-relative">
                        <label className="label-field" htmlFor="attorney">Abogado a cargo</label>
                        <input type="text" autoComplete='off' className="input-field" id="user" placeholder="Buscar por nombres, apellidos o documento" onChange={handleSearchChange} name="attorneyText" value={form.attorneyText}></input>
                        <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'user') ? "active" : ""}`}>
                            { dropdown.data.length > 0 ?
                                dropdown.data.map((option, index) => (
                                <div key={index} className="dropdown-item-container" onClick={() => setAttorneyData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document} TP: {option.professionalCard}</div>
                                ))
                            :
                                <span className="dropdown-message-item">Sin resultados  
                                    { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/usuarios/nuevo"}>, ¿crear?</a> : null}                        
                                </span>
                            }
                        </div>
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field representative" htmlFor="representative">Personero delegado &#47; Funcionario sustenciador</label>
                        <input type="text" className="input-field" id="representative" name="representative" autoComplete="off" placeholder="" onChange={handleInputChange}></input>
                    </div>
                    <h4 className="w-100 my-2">Datos del cliente</h4>
                    <div className="d-flex flex-column w-3 field position-relative">
                        <label className="label-field" htmlFor="client">Cliente</label>
                        <input type="text" autoComplete='off' className="input-field" id="client" placeholder="Buscar por nombres, apellidos o documento" onChange={handleSearchChange} name="clientText" value={form.clientText}></input>
                        <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'client') ? "active" : ""}`}>
                            { dropdown.data.length > 0 ?
                                dropdown.data.map((option, index) => (
                                <div key={index} className="dropdown-item-container" onClick={() => setClientData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document}</div>
                                ))
                            :
                                <span className="dropdown-message-item">Sin resultados, <a target="_blank" rel="noreferrer" href={"/clientes/nuevo"}>¿crear?</a></span>
                            }
                        </div>
                    </div>
                    <div  className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="position">Cargo</label>
                        <input name="position" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleCaseInputChange}></input>
                    </div>
                    <div  className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="statePosition">Estado del cargo</label>
                        <select className="input-field" id="statePosition" name="statePosition" onChange={handleCaseInputChange}>
                            <option></option>
                            <option value="actual">Actualmente</option>
                            <option value="ex">Ex</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="territorialEntity">Entidad territorial</label>
                        <select className="input-field" id="territorialEntity" name="territorialEntity" onChange={handleCaseInputChange}>
                            <option></option>
                            {territorialEntity.map((value) => (
                                <option key={'territorialEntity' + value} value={value}>{value}</option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex flex-column w-3 field">
                        <label className="label-field" htmlFor="executionProvince">Departamento de ejecución</label>
                        <select className="input-field" id="executionProvince" name="executionProvince" onChange={(e) =>handleOnChange(e, 'client')}>
                            <option></option>
                            {provinces.map((province) => (
                                <option key={province.name} value={province.name}>{province.name}</option>
                            ))}
                        </select>
                    </div>
                    {form.case.executionProvince !== '' && citiesData.clientCities && citiesData.clientCities !== [] && 
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="executionCity">Ciudad de ejecución</label>
                            <select className="input-field" id="executionCity" name="executionCity" onChange={handleCaseInputChange}>
                                <option></option>
                                {citiesData.clientCities.map((city) => (
                                    <option key={'executionCity' + city.name} value={city.name}>{city.name}</option>
                                ))}
                            </select>
                        </div>
                    }
                    <h4 className="w-100 my-2">Datos particulares</h4>
                    <div  className="d-flex flex-column w-100 field">
                        <label className="label-field" htmlFor={'summary'}>Resumen</label>
                        <textarea id={'summary'} name={'summary'} placeholder={placeholders.summary} autoComplete="off" rows={5} cols={5} className="input-field" type="number" onChange={handleInputChange}></textarea>
                    </div>
                    <div  className="d-flex flex-column w-100 field">
                        <label className="label-field" htmlFor={'observation'}>Observaciones</label>
                        <textarea id={'observation'} name={'observation'} placeholder={placeholders.observation} autoComplete="off" rows={5} cols={5} className="input-field" type="number" onChange={handleInputChange}></textarea>
                    </div>
                    <div  className="d-flex flex-column w-100 field">
                        <label className="label-field" htmlFor={'events'}>Acontecimientos</label>
                        <textarea id={'events'} name={'events'} placeholder={placeholders.events} autoComplete="off" rows={5} cols={5} className="input-field" type="number" onChange={handleInputChange}></textarea>
                    </div>
                    <div  className="d-flex flex-column w-50 field">
                        <label className="label-field" htmlFor="instance">Instancia</label>
                        <select className="input-field" id="instance" name="instance" onChange={handleInputChange}>
                            <option></option>
                            <option value="única">Única</option>
                            <option value="doble">Doble</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column w-50 field">
                        <label className="label-field" htmlFor="autoOpening">Auto de apertura</label>
                        <input type="text" className="input-field" id="autoOpening" placeholder="Ej: 1600.20.11.20.088" onChange={handleInputChange} name="autoOpening"></input>
                    </div>
                    <div className="d-flex flex-column w-50 field">
                        <label className="label-field">Fecha del auto de apertura</label>
                        <DatePicker
                            value={ form.autoOpeningDate }
                            dayAriaLabel={"Día"}
                            dayPlaceholder={"dd"}
                            monthAriaLabel={"Mes"}
                            monthPlaceholder={"mm"}
                            yearAriaLabel={"Año"}
                            yearPlaceholder={"yyyy"}
                            name={"autoOpeningDate"}
                            onChange={ (date)=>handleDateChange( 'autoOpeningDate', date ) }
                            dateFormat="MM/dd/yyyy"
                        />
                    </div>
                    <div className="d-flex flex-column w-50 field">
                        <label className="label-field">Fecha de notificación</label>
                        <DatePicker
                            value={ form.notificationDate }
                            dayAriaLabel={"Día"}
                            dayPlaceholder={"dd"}
                            monthAriaLabel={"Mes"}
                            monthPlaceholder={"mm"}
                            yearAriaLabel={"Año"}
                            yearPlaceholder={"yyyy"}
                            name={"notificationDate"}
                            onChange={ (date)=>handleDateChange( 'notificationDate', date ) }
                            dateFormat="MM/dd/yyyy"
                        />
                    </div>
                    <div className="d-flex justify-content-center w-100 my-2">
                        <button type="submit" className="primary-button save-button">Generar</button>
                    </div>
                </form>
            </div>
        </div>
    );

}

export default CreateCase;
  